// import logo from "./asset-source/logo.gif";
import "./typo.css";
import "./services.css";
import "./newfooter.css";

import logoW from "./asset-source/logo-w.svg";
import close from "./asset-source/close.svg";
import services from "./asset-source/services.svg";
import Slider from "react-slick";

import sl1 from "./asset-source/sl1.svg";
import sl2 from "./asset-source/sl2.svg";
import sl3 from "./asset-source/sl3.svg";
import sl4 from "./asset-source/sl4.svg";
import sl5 from "./asset-source/sl5.svg";
import sl6 from "./asset-source/sl6.svg";
import sl7 from "./asset-source/sl7.svg";
import sl8 from "./asset-source/sl8.svg";
import tg from "./asset-source/tg.svg";
import chevron from "./asset-source/chevron.svg";

import { Footer } from "./components/footer/footer";

import { useState, useEffect } from "react";
import Cases from "./components/cases/cases";
import CasesAudit from "./components/cases/cases-audit";
import CasesPrototype from "./components/cases/cases-prototype";
import CasesBrend from "./components/cases/cases-brending";
import { Header } from "./components/header-new/header";

import ContactUsModal from "./components/modal/contact-us";
import { useNavigate } from "react-router-dom";

function ServicesPage() {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [currentField, setCurrentField] = useState("");
  const [nameUser, setNameUser] = useState("");
  const [contacts, setContact] = useState("");
  const [textfield, setTextfield] = useState("");
  const [time, setTime] = useState("1 мес");
  const [budget, setBudget] = useState(3);

  const [consultingAccrodeon, setConsultingAccrodeon] = useState(0);
  const [projectsAccrodeon, setProjectsAccrodeon] = useState(0);
  const [designAccrodeon, setDesignAccrodeon] = useState(0);
  const [brandingAccrodeon, setBrandingAccrodeon] = useState(0);
  const [supportAccrodeon, setSupportAccrodeon] = useState(0);

  const navigate = useNavigate();

  function handleConsultingAccrodeon(num) {
    if (consultingAccrodeon === num) {
      setConsultingAccrodeon(0);
    } else {
      setConsultingAccrodeon(num);
    }
  }

  function handleProjectsAccrodeon(num) {
    if (projectsAccrodeon === num) {
      setProjectsAccrodeon(0);
    } else {
      setProjectsAccrodeon(num);
    }
  }

  function handleDesignAccrodeon(num) {
    if (designAccrodeon === num) {
      setDesignAccrodeon(0);
    } else {
      setDesignAccrodeon(num);
    }
  }

  function handleBrandingAccrodeon(num) {
    if (brandingAccrodeon === num) {
      setBrandingAccrodeon(0);
    } else {
      setBrandingAccrodeon(num);
    }
  }

  function handleSupportAccrodeon(num) {
    if (supportAccrodeon === num) {
      setSupportAccrodeon(0);
    } else {
      setSupportAccrodeon(num);
    }
  }

  document.title =
    "Wjet – Юзабилити, дизайн и разработка цифровых продуктов для бизнеса";
  document.getElementsByTagName("META")[2].content =
    "Консультирование, аудит пользовательского опыта, UI/UX аудит, проектирование и дизайн интерфейсов, создание дизайн-систем для цифровых продуктов";

  document.getElementsByTagName("META")[3].content =
    "UX-исследования, Юзабилити-аудит, UX аудит, Дизайн интерфейсов, UX/UI проектирование, UI/UX дизайн, UI/UX для цифровых продуктов, Дизайн интерфейсов для приложений, Интерактивный прототип, Веб-дизайн, Адаптивный веб-дизайн, Создание MVP, Дизайн-система продукта";

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 14000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // useEffect(() => {
  // 	if (modal || isMenuActive) {
  // 		document.body.style.overflow = "hidden";
  // 	} else {
  // 		document.body.style.overflow = "auto";
  // 	}
  // }, [modal, isMenuActive]);

  return (
    <div
      className="App"
      onClick={() => {
        setCurrentField("");
      }}
    >
      <Header onLight />

      <section
        className="top"
        id="top"
      >
        <div className="dotz">
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine"></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine unshine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine"></div>
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item "></div>
              <div className="dotz__item "></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine delay3"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item inshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item unshine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay3"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine delay2"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item dotz__item--empty"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item inshine delay2"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item shine4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item unshine4"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay1"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item shine"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay3"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item shine delay2"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item shine delay4"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item unshine"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item shine delay1"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item unshine4"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
          <div className="dotz__row">
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item "></div>
            <div className="dotz__item "></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="dotz__item"></div>
            <div className="hide--mobile">
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
              <div className="dotz__item"></div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="subtitle">Студия цифрового дизайна</div>
          <h1 className="h1">
            Мы помогаем создавать цифровое будущее для вашей компании
          </h1>

          <div className="services__grid">
            <a
              href="#research"
              className="services__unit"
            >
              <img
                src={services}
                alt=""
                className="services__icon"
              />
              <div className="services__title">Исследуем</div>
              <div>
                Изучаем потребности пользователей и&nbsp;анализируем рынок,
                чтобы&nbsp;найти ключевые возможности и&nbsp;создать
                для&nbsp;вас&nbsp;идеальный цифровой продукт или&nbsp;улучшить
                существующий.
              </div>
            </a>
            <a
              href="#project"
              className="services__unit"
            >
              <img
                src={services}
                alt=""
                className="services__icon"
              />
              <div className="services__title">Проектируем</div>
              <div>
                Превращаем идеи в&nbsp;интерактивные прототипы, тестируем
                и&nbsp;улучшаем пользовательские сценарии, разрабатываем гибкие
                и&nbsp;масштабируемые дизайн-системы.
              </div>
            </a>
          </div>

          <div className="services__grid services__grid--reverse">
            <a
              href="#designing"
              className="services__unit"
            >
              <img
                src={services}
                alt=""
                className="services__icon"
              />
              <div className="services__title">Дизайним</div>
              <div>
                Вкладываем душу в&nbsp;каждый продукт: разрабатываем UI/UX,
                веб-сайты и&nbsp;брендинг, которые находят отклик
                у&nbsp;пользователей и&nbsp;помогают бизнесу достигать
                выдающихся результатов.
              </div>
            </a>
            <a
              href="#support"
              className="services__unit"
            >
              <img
                src={services}
                alt=""
                className="services__icon"
              />
              <div className="services__title">Поддерживаем</div>
              <div>
                Оказываем дизайн-поддержку вашим проектам на&nbsp;всех этапах,
                оптимизируем их&nbsp;и&nbsp;совершенствуем, чтобы&nbsp;ваши kpi
                улетали в&nbsp;космос.
              </div>
            </a>
          </div>
        </div>
      </section>

      <section
        className="section"
        id="research"
      >
        <div className="container">
          <div className="section__headingblock">
            <h2 className="h2">Исследования и консультации</h2>
            <div className="section__description">
              Проконсультируем вас&nbsp;по&nbsp;любым вопросам, связанным
              с&nbsp;созданием и&nbsp;улучшением ваших цифровых продуктов.
              Проведём аудит пользовательского опыта и&nbsp;исследуем поведение
              пользователей, чтобы&nbsp;воплотить все&nbsp;ваши идеи
              и&nbsp;создать интуитивно понятный и&nbsp;эффективный цифровой
              продукт.
              <br />
              Более 10&nbsp;лет&nbsp;мы&nbsp;занимаемся созданием цифровых
              решений для&nbsp;бизнеса и&nbsp;точно знаем, как&nbsp;определять
              интересы пользователей и&nbsp;создавать продукты, полностью
              отвечающие их&nbsp;задачам и&nbsp;ожиданиям.
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Консалтинг</h3>
            <div>
              <div
                className={
                  consultingAccrodeon === 1
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Консультации по&nbsp;любым вопросам, связанным с&nbsp;UX/UI,
                продуктовой стратегией и&nbsp;цифровой трансформацией.
              </div>
              {/* <div
								className="principle__showmore"
								onClick={() => handleConsultingAccrodeon(1)}
							>
								{consultingAccrodeon === 1 ? "Свернуть" : "Развернуть"}
								<img
									src={chevron}
									alt=""
									className={
										consultingAccrodeon === 1 ? "chvron chvron--active" : "chvron"
									}
								/>
							</div> */}
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">UX-исследования</h3>
            <div>
              <div
                className={
                  consultingAccrodeon === 2
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Проведём анализ поведения пользователей, юзабилити-тесты
                и&nbsp;опросы, чтобы&nbsp;выявить проблемные точки
                и&nbsp;оптимизировать интерфейс для&nbsp;лучшего
                пользовательского опыта. UX-исследования помогают понять,
                что&nbsp;важно вашим пользователям
                и&nbsp;как&nbsp;они&nbsp;взаимодействуют с&nbsp;продуктом.
                На&nbsp;основе полученных данных разрабатываем рекомендации,
                адаптированные под&nbsp;задачи вашего бизнеса и&nbsp;специфику
                продукта.
                <a href="/audit" className="audit__link">Подробнее об услуге</a>
              </div>

              <div
                className="principle__showmore"
                onClick={() => handleConsultingAccrodeon(2)}
              >
                {consultingAccrodeon === 2 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    consultingAccrodeon === 2
                      ? "chvron chvron--active"
                      : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Продуктовые исследования</h3>
            <div>
              <div
                className={
                  consultingAccrodeon === 3
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Проведём анализ предпочтений пользователей, изучим рынок
                и&nbsp;лучшие решения конкурентов, чтобы&nbsp;найти возможности
                для&nbsp;роста и&nbsp;улучшений. Продуктовые исследования
                помогают глубже понять потребности целевой аудитории
                и&nbsp;определить ключевые метрики. Мы&nbsp;находим оптимальные
                рабочие решения и&nbsp;создаём продукт, точно соответствующий
                ожиданиям клиентов для&nbsp;достижения результатов бизнеса.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleConsultingAccrodeon(3)}
              >
                {consultingAccrodeon === 3 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    consultingAccrodeon === 3
                      ? "chvron chvron--active"
                      : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">
              Юзабилити-аудит/ Аудит пользовательского опыта продукта
            </h3>
            <div>
              <div
                className={
                  consultingAccrodeon === 4
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Проведём аудит пользовательского опыта, чтобы&nbsp;оценить,
                насколько удобно вашим пользователям пользоваться продуктом.
                На&nbsp;основе анализа пользовательских действий
                и&nbsp;тестирования интерфейсов найдём проблемные точки
                и&nbsp;предложим решения для&nbsp;оптимизации и&nbsp;улучшения
                вашего цифрового продукта.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleConsultingAccrodeon(4)}
              >
                {consultingAccrodeon === 4 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    consultingAccrodeon === 4
                      ? "chvron chvron--active"
                      : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <button
            className="action__button"
            onClick={() => {
              navigate(`?modal`);
            }}
          >
            Записаться на консультацию
          </button>

          <div className="cases__wrapper">
            <CasesAudit />
          </div>
        </div>
      </section>

      <section
        className="section"
        id="project"
      >
        <div className="container">
          <div className="section__headingblock">
            <h2 className="h2">Проектирование</h2>
            <div className="section__description">
              Проектируем красивые и&nbsp;функциональные интерфейсы,
              разрабатываем прототипы и&nbsp;создаём дизайн-системы,
              чтобы&nbsp;ваши продукты были не&nbsp;только привлекательными,
              но&nbsp;и&nbsp;интуитивно понятными для&nbsp;пользователей.
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Проектирование интерфейсов</h3>
            <div>
              <div
                className={
                  projectsAccrodeon === 1
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создадим удобный и&nbsp;интуитивный интерфейс для&nbsp;цифрового
                продукта любой сложности&nbsp;— от&nbsp;простого мобильного
                приложения до&nbsp;сложных корпоративных платформ
                и&nbsp;e-commerce решений. Мы&nbsp;разрабатываем интерфейсы,
                тестируем и&nbsp;дорабатываем прототипы,
                чтобы&nbsp;ваш&nbsp;продукт максимально соответствовал
                потребностям пользователей и&nbsp;бизнес-целям.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleProjectsAccrodeon(1)}
              >
                {projectsAccrodeon === 1 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    projectsAccrodeon === 1 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">
              Разработка интерактивных прототипов продуктов
            </h3>
            <div>
              <div
                className={
                  projectsAccrodeon === 2
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создадим детализированные интерактивные прототипы для&nbsp;ваших
                цифровых продуктов, чтобы&nbsp;не&nbsp;только визуализировать,
                но&nbsp;и&nbsp;протестировать будущий функционал
                ещё&nbsp;до&nbsp;начала разработки. Вы&nbsp;сможете увидеть,
                как&nbsp;будет выглядеть и&nbsp;работать продукт, внести правки
                на&nbsp;ранних этапах и&nbsp;избежать дорогостоящих доработок.
              </div>

              <div
                className="principle__showmore"
                onClick={() => handleProjectsAccrodeon(2)}
              >
                {projectsAccrodeon === 2 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    projectsAccrodeon === 2 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">
              Проектирование пользовательских сценариев
            </h3>
            <div>
              <div
                className={
                  projectsAccrodeon === 3
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Проектирование пользовательских сценариев для&nbsp;цифровых
                продуктов&nbsp;— это&nbsp;инструмент для&nbsp;визуализации пути
                пользователя от&nbsp;первого знакомства с&nbsp;продуктом
                до&nbsp;момента регистрации, оплаты или&nbsp;любого другого
                целевого действия. Мы&nbsp;разрабатываем сценарии с&nbsp;учётом
                потребностей, целей и&nbsp;ожиданий вашей аудитории,
                чтобы&nbsp;каждый элемент интерфейса направлял пользователей
                к&nbsp;целевым действиям. Это&nbsp;повышает вовлеченность
                пользователей и&nbsp;эффективность продукта, что&nbsp;напрямую
                влияет на&nbsp;рост бизнеса.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleProjectsAccrodeon(3)}
              >
                {projectsAccrodeon === 3 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    projectsAccrodeon === 3 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <button
            className="action__button"
            onClick={() => {
              navigate(`?modal`);
            }}
          >
            Обсудить продукт
          </button>

          <div className="cases__wrapper">
            <CasesPrototype />
          </div>
        </div>
      </section>

      <section
        className="section"
        id="designing"
      >
        <div className="container">
          <div className="section__headingblock">
            <h2 className="h2">Дизайн цифрового продукта</h2>
            <div className="section__description">
              Создаём цифровые продукты, которыми пользователи
              с&nbsp;удовольствием пользуются и&nbsp;охотно рекомендуют друзьям.
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">UI/UX дизайн</h3>
            <div>
              <div
                className={
                  designAccrodeon === 1
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создаём визуально привлекательный и&nbsp;интуитивный дизайн
                интерфейсов для&nbsp;веб-приложений, сервисов,
                интернет-магазинов и&nbsp;мобильных приложений.
                При&nbsp;разработке мы&nbsp;всегда ориентируемся
                на&nbsp;потребности вашей аудитории и&nbsp;заботимся
                о&nbsp;пользовательском опыте. Нам&nbsp;важно,
                чтобы&nbsp;пользоваться вашим цифровым продуктом было удобно
                и&nbsp;приятно.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleDesignAccrodeon(1)}
              >
                {designAccrodeon === 1 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    designAccrodeon === 1 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Веб-дизайн</h3>
            <div>
              <div
                className={
                  designAccrodeon === 2
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создаём корпоративные сайты, промо-сайты, интернет-магазины,
                лендинги и&nbsp;порталы, которые не&nbsp;только привлекают
                внимание, но&nbsp;и&nbsp;точно отражают характер и&nbsp;ценности
                вашей компании. Мы&nbsp;тщательно продумываем каждый элемент
                вашего сайта, чтобы&nbsp;посетители интуитивно переходили
                к&nbsp;целевым страницам и&nbsp;не&nbsp;отвлекались
                на&nbsp;лишние детали.
              </div>

              <div
                className="principle__showmore"
                onClick={() => handleDesignAccrodeon(2)}
              >
                {designAccrodeon === 2 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    designAccrodeon === 2 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">
              Создание MVP (быстрый запуск продукта)
            </h3>
            <div>
              <div
                className={
                  designAccrodeon === 3
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создание MVP для&nbsp;быстрого выхода на&nbsp;рынок&nbsp;—
                это&nbsp;возможность протестировать вашу идею и&nbsp;оценить
                спрос на&nbsp;продукт с&nbsp;минимальными затратами
                и&nbsp;в&nbsp;сжатые сроки (1–2&nbsp;месяца).
                Мы&nbsp;разрабатываем базовую версию с&nbsp;ключевыми функциями,
                чтобы&nbsp;она&nbsp;решала основные задачи. Это&nbsp;позволяет
                привлечь первых пользователей, получить обратную связь
                и&nbsp;внести улучшения без&nbsp;затрат на&nbsp;полную
                разработку.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleDesignAccrodeon(3)}
              >
                {designAccrodeon === 3 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    designAccrodeon === 3 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Разработка дизайн-системы</h3>
            <div>
              <div
                className={
                  designAccrodeon === 4
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создадим единую дизайн-систему для&nbsp;ваших цифровых
                продуктов, чтобы&nbsp;стандартизировать визуальный стиль
                и&nbsp;элементы интерфейса, обеспечив целостный
                и&nbsp;профессиональный внешний&nbsp;вид. Разработка
                дизайн-системы становится необходимым элементом
                при&nbsp;создании цифровых продуктов неспроста&nbsp;—
                она&nbsp;не&nbsp;только ускоряет процесс разработки
                и&nbsp;упрощает взаимодействие команд,
                но&nbsp;и&nbsp;гарантирует, что&nbsp;каждый элемент продукта
                соответствует единому стилю. Кроме того, наличие дизайн-системы
                снижает вероятность ошибок и&nbsp;делает внесение изменений
                проще, что&nbsp;особенно важно для&nbsp;стабильного развития
                продукта.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleDesignAccrodeon(4)}
              >
                {designAccrodeon === 4 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    designAccrodeon === 4 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="discuss">
            Давайте обсудим вашу идею?
            <button
              className="action__button"
              onClick={() => {
                navigate(`?modal`);
              }}
            >
              Обсудить продукт
            </button>
          </div>

          <div className="cases__wrapper">
            <Cases />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section__headingblock">
            <h2 className="h2">Брендинг и айдентика</h2>
            <div className="section__description">
              Создаём уникальный брендинг и&nbsp;айдентику, которые запомнятся
              пользователям и&nbsp;помогут вашему бизнесу выделиться
              на&nbsp;фоне конкурентов.
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Брендинг и айдентика</h3>
            <div>
              <div
                className={
                  brandingAccrodeon === 1
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Создадим для&nbsp;вас&nbsp;визуальный образ, который будет
                отражать ценности и&nbsp;характер вашего бренда и&nbsp;выделит
                вас&nbsp;на&nbsp;рынке. Логотип, фирменный стиль, цветовая
                палитра и&nbsp;другие ключевые элементы сделают ваш&nbsp;бренд
                целостным и&nbsp;легко узнаваемым.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleBrandingAccrodeon(1)}
              >
                {brandingAccrodeon === 1 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    brandingAccrodeon === 1 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Продакшн и графический дизайн</h3>
            <div>
              <div
                className={
                  brandingAccrodeon === 2
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Продакшн и&nbsp;графический дизайн для&nbsp;успешной визуальной
                коммуникации. Мы&nbsp;создаём визуальный контент, который
                помогает вашему бренду рассказывать истории, привлекать внимание
                и&nbsp;выделяться среди конкурентов. Наша команда предлагает
                2D/3D-анимацию, графику для&nbsp;сайтов и&nbsp;визуализацию
                продукта. Мы&nbsp;тщательно продумываем каждый элемент,
                чтобы&nbsp;создать яркий и&nbsp;запоминающийся образ.
              </div>

              <div
                className="principle__showmore"
                onClick={() => handleBrandingAccrodeon(2)}
              >
                {brandingAccrodeon === 2 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    brandingAccrodeon === 2 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <button
            className="action__button"
            onClick={() => {
              navigate(`?modal`);
            }}
          >
            Обсудить бренд-стратегию
          </button>

          <div className="cases__wrapper">
            <CasesBrend />
          </div>
        </div>
      </section>

      <section
        className="section"
        id="support"
      >
        <div className="container">
          <div className="section__headingblock">
            <h2 className="h2">Дизайн-поддержка и&nbsp;сопровождение</h2>
            <div className="section__description">
              Предоставляем дизайн-поддержку на&nbsp;всех этапах вашего проекта,
              оптимизируем и&nbsp;совершенствуем каждый элемент,
              чтобы&nbsp;ваш&nbsp;продукт постоянно развивался и&nbsp;рос.
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Дизайн-поддержка</h3>
            <div>
              <div
                className={
                  supportAccrodeon === 1
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Дизайн поддержка&nbsp;— это&nbsp;комплекс услуг
                по&nbsp;продуктовому дизайну. Мы&nbsp;занимаемся разработкой
                и&nbsp;развитием интерфейсов, проведением A/B-тестирования
                и&nbsp;интервью с&nbsp;пользователями. Наша команда решает
                текущие задачи продукта, внедряет новые функции, проводит
                редизайн и&nbsp;проверяет гипотезы. Мы&nbsp;обеспечиваем
                постоянную поддержку и&nbsp;оптимизацию,
                чтобы&nbsp;ваш&nbsp;продукт оставался актуальным
                и&nbsp;соответствовал ожиданиям пользователей.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleSupportAccrodeon(1)}
              >
                {supportAccrodeon === 1 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    supportAccrodeon === 1 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">
              Подготовка технических заданий для разработчиков
            </h3>
            <div>
              <div
                className={
                  supportAccrodeon === 2
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Подготовка технических заданий для&nbsp;разработчиков включает
                создание всех материалов, необходимых для&nbsp;эффективной
                работы команды, от&nbsp;UI-китов до&nbsp;дизайн-документации
                и&nbsp;дизайн-систем в&nbsp;Figma. Это&nbsp;помогает всем
                участникам команды чётко понять, что&nbsp;нужно сделать,
                и&nbsp;следовать установленным правилам, что&nbsp;в&nbsp;итоге
                приводит к&nbsp;успешной реализации проекта.
              </div>

              <div
                className="principle__showmore"
                onClick={() => handleSupportAccrodeon(2)}
              >
                {supportAccrodeon === 2 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    supportAccrodeon === 2 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <div className="inforow">
            <h3 className="inforow__title">Разработка цифровых продуктов</h3>
            <div>
              <div
                className={
                  supportAccrodeon === 3
                    ? "principle__content principle__content--active"
                    : "principle__content"
                }
              >
                Разработка цифровых продуктов с&nbsp;привлечением
                к&nbsp;технической части работ надёжных партнёров,
                с&nbsp;которыми мы&nbsp;сотрудничаем уже&nbsp;много&nbsp;лет.
                Наша команда сопровождает проект на&nbsp;всех этапах&nbsp;—
                от&nbsp;концепции до&nbsp;запуска, обеспечивая соответствие всем
                требованиям и&nbsp;стандартам. Мы&nbsp;превращаем идеи
                в&nbsp;успешные цифровые продукты.
              </div>
              <div
                className="principle__showmore"
                onClick={() => handleSupportAccrodeon(3)}
              >
                {supportAccrodeon === 3 ? "Свернуть" : "Развернуть"}
                <img
                  src={chevron}
                  alt=""
                  className={
                    supportAccrodeon === 3 ? "chvron chvron--active" : "chvron"
                  }
                />
              </div>
            </div>
          </div>

          <a
            href="/cases"
            className="action__button"
          >
            Посмотреть все проекты студии
          </a>
        </div>
      </section>

      <section
        className="design"
        id="design"
      >
        <div className="container">
          <div className="slider">
            <Slider
              className="slider__init"
              {...settings}
            >
              <div className="slider__item">
                <img
                  src={sl1}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl2}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl3}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl4}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl5}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl6}
                  alt=""
                />
              </div>
              <div className="slider__item">
                <img
                  src={sl7}
                  alt=""
                />
              </div>

              <div className="slider__item">
                <img
                  src={sl8}
                  alt=""
                />
              </div>
            </Slider>
          </div>
        </div>

        <div
          className="container"
          id="contacts"
        >
          <Footer backgroundColor="transparent" />
        </div>
      </section>

      <ContactUsModal />
    </div>
  );
}

export default ServicesPage;
